import { render, staticRenderFns } from "./SpinnerCard.vue?vue&type=template&id=06f29052&scoped=true&"
import script from "./SpinnerCard.vue?vue&type=script&lang=ts&"
export * from "./SpinnerCard.vue?vue&type=script&lang=ts&"
import style0 from "./SpinnerCard.vue?vue&type=style&index=0&id=06f29052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f29052",
  null
  
)

export default component.exports